import ButtonDefault from 'ui/src/buttons/ButtonDefault'
import TooltipDefault from 'ui/src/tooltip/TooltipDefault'
import InputText from 'ui/src/inputs/InputText'
import InputTextArea from 'ui/src/inputs/InputTextArea'
import InputSelect from 'ui/src/inputs/InputSelect'
import InputRadio from 'ui/src/inputs/InputRadio'
import InputCheckBox from 'ui/src/inputs/InputCheckBox'
import styles from 'ui/src/styles/components/parts/Input.module.scss'
import { useEffect, useState } from 'react'
import { useLocale } from '@/features/i18n/hooks/useLocale'
import { TResearchAchievement } from '@/libs/types/TResearchAchievement'

interface Props {
  className?: string
  isOpen?: boolean
  data?: TResearchAchievement
  onClose?: () => void
  saveAction?: (data: TResearchAchievement) => void
}

interface Errors {
  date?: string
  researchAchievementName?: string
}

export default function TableModalAwardEdit({
  className,
  isOpen,
  data,
  onClose,
  saveAction,
}: Props) {
  const { locale, t } = useLocale()

  const [inputs, setInputs] = useState<TResearchAchievement>({
    researchAchievementId: 0,
    personId: '',
    researchAchievementName: '',
    researchAchievementDate: '',
  })
  const [errors, setErrors] = useState<Errors>({})

  useEffect(() => {
    if (isOpen) {
      setErrors({})
    }
  }, [isOpen])
  useEffect(() => {
    if (isOpen && data) {
      setInputs({ ...data })
    } else {
      setInputs({
        researchAchievementId: 0,
        personId: '',
        researchAchievementName: '',
        researchAchievementDate: '',
      })
    }
  }, [isOpen, data])

  const submitAction = () => {
    let newErrors: Errors = {}
    if (!inputs.researchAchievementDate) {
      newErrors = {
        ...newErrors,
        date: inputs.researchAchievementDate ? '' : t.validate.required,
      }
    }
    if (!inputs.researchAchievementName) {
      newErrors = {
        ...newErrors,
        researchAchievementName: inputs.researchAchievementName ? '' : t.validate.required,
      }
    }

    console.log(inputs)

    setErrors(newErrors)
    if (Object.keys(newErrors).length > 0) {
      return
    }

    saveAction?.(inputs)
    onClose?.()
  }

  const days: [number, string][] = [...new Array(31).keys()].map((day) => [
    day + 1,
    `${day + 1}${locale === 'ja' ? '日' : ''}`,
  ])

  return (
    <>
      <table className="mb-5">
        <tbody>
          <tr>
            <th className="font-bold">
              <div className="flex gap-1 items-center">
                {t.profile.Date}
                <span className={styles.input__must}>{t.validate.requiredLabel}</span>
              </div>
            </th>
          </tr>
          <tr>
            <td>
              <div className="flex gap-2">
                <input
                  type="text"
                  className={`${styles.inputText} ${styles.inputText__l} ${styles.gray}`}
                  placeholder={'YYYY/MM'}
                  value={inputs.researchAchievementDate ?? ''}
                  onChange={(e) =>
                    setInputs({ ...inputs, researchAchievementDate: e.target.value })
                  }
                />
              </div>
              <span className={styles.error}>{errors.date}</span>
            </td>
          </tr>
          <tr>
            <th className="font-bold">
              <div className="flex gap-1 items-center">
                {t.profile.AwardAndCertifiedName}
                <span className={styles.input__must}>{t.validate.requiredLabel}</span>
              </div>
            </th>
          </tr>
          <tr>
            <td>
              <input
                type="text"
                className={`${styles.inputText} ${styles.inputText__l} ${styles.gray}`}
                placeholder={t.profile.PaperTitlePlaceholder}
                value={inputs.researchAchievementName}
                onChange={(e) => setInputs({ ...inputs, researchAchievementName: e.target.value })}
              />
              <span className={styles.error}>{errors.researchAchievementName}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <hr className="hr mb-7" />
      <div className="flex gap-5 justify-center">
        <ButtonDefault label={t.button.Cancel} color="secondary" action={onClose} />
        <ButtonDefault label={t.button.Save} color="primary" action={submitAction} />
      </div>
    </>
  )
}
